/** @file Prunes base track t's mirrorFix chain: links whose owner left t's crossfade leave silently (R19-02). */
import type { AnimState, TrackEntry } from '../../contracts/state';
import { fixTrackOf } from './fixTrackOf';
import { ownerCover } from './ownerCover';

/**
 * Unlinks every link of track BASE_TRACKS + `track` whose owner has left base track `track`'s from-chain or is fully
 * covered (ownerCover 0: a disposed owner, a never-played owner replaced, a mix of 0), and every link of `replaced`
 * when given (playDirectional swapping the fix of an entry it keeps). Links leave silently, with no end/dispose
 * (W2-12); the bottom kept link drops its mixDirs (null without a from-entry, CR-010); when no link stays the track is
 * null (fix tracks never queue). Allocation-free: stepState calls it for every base track every step.
 */
export function releaseFixLayer(state: AnimState, track: number, replaced: TrackEntry | null = null): void {
  const fixTrack = fixTrackOf(track);
  let kept: TrackEntry | null = null;
  for (let e = state.tracks[fixTrack] ?? null; e !== null; e = e.from) {
    if (e.owner !== null && e.owner !== replaced && ownerCover(state, track, e.owner) > 0) kept = e;
    else if (kept === null) state.tracks[fixTrack] = e.from;
    else kept.from = e.from;
  }
  if (kept !== null && kept.from === null) kept.mixDirs = null;
}
